<template>
  <div>
    <b-progress v-if="'trueValue' in column && 'falseValue' in column"
      :id="`distribution-count-${column.name}`">
      <b-progress-bar :value="fillRate" :variant="variant || 'success'">
        <span class="progress-label fw-bold">
          {{ label != null ? label : column.numFills }}
        </span>
      </b-progress-bar>
      <b-progress-bar :value="100 - fillRate" variant="secondary" />
    </b-progress>
    <b-progress
      v-else-if="showNonZeroRate(column)"
      title="Empty values (zero or nulls)"
    >
      <b-progress-bar :value="fillRate" :variant="variant || 'info'" class="text-white">
        <span class="progress-label fw-bold">
          {{ label != null ? label : intComma(nonZeroCount(column)) }}
        </span>
      </b-progress-bar>
      <b-progress-bar :value="100 - fillRate" variant="secondary" />
    </b-progress>
    <b-progress v-else>
      <b-progress-bar :value="fillRate" :variant="variant || 'primary'">
        <span class="progress-label fw-bold">
          {{ label != null ? label : column.numFills }}
        </span>
      </b-progress-bar>
      <b-progress-bar :value="100 - fillRate" variant="secondary" />
    </b-progress>
    <b-popover v-if="'trueValue' in column && 'falseValue' in column"
      :target="`distribution-count-${column.name}`" hover placement="top">
      <div>
        <span class="px-2 me-2 bg-success" />
        {{ column.trueValue }}:
        {{ column.numFills }}
      </div>
      <div>
        <span class="px-2 me-2 bg-secondary" />
        {{ column.falseValue }}:
        {{ intComma(leftFillValues(column.numFills)) }}
      </div>
    </b-popover>
  </div>
</template>

<script>
import Humanize from "humanize-plus";
import { parseStat } from "../../modules/reportStats.js";

export default {
  props: {
    column: { type: Object, default: null },
    totalRows: { type: Number, default: null },
    variant: { type: String, default: null },
    // Overrides the in-bar label text (used by the Relative Coverage metric to
    // show the percentage instead of the raw fill count).
    label: { type: String, default: null },
  },
  computed: {
    // fillRate arrives as an int (13), a decimal string ("5.527") or null
    // (column without statistics); clamp it to a number in [0, 100] so the
    // two bars always add up to exactly 100%.
    fillRate() {
      const rate = parseStat(this.column.fillRate);
      return Math.min(100, Math.max(0, rate == null ? 0 : rate));
    },
  },
  methods: {
    intComma: Humanize.intComma,
    nonZeroCount(column) {
      return (parseStat(column.numFills) || 0) - (parseStat(column.numZero) || 0);
    },
    leftFillValues(value) {
      return this.totalRows - (parseStat(value) || 0);
    },
    showNonZeroRate(column) {
      return column.type === "int-non-zero" && parseStat(column.numZero) != null;
    },
  },
};
</script>

<style scoped>
/* Was a `<big>` element; Vue 3 does not know that (deprecated) tag and warns
   "Failed to resolve component: big", so use a span with the same sizing. */
.progress-label {
  font-size: larger;
}
</style>
